import { AuthProvider, TAuthConfig } from 'react-oauth2-code-pkce'
import { useSearchParams } from 'react-router-dom'

import {
  OAUTH_AUTH_API,
  OAUTH_ClIENT_ID,
  OAUTH_CLIENT_SECRET,
  OAUTH_REDIRECT_URI,
  OAUTH_TOKEN_API,
} from '@constants/index'

interface OAuth2ProviderProps {
  children: React.ReactNode
}

export const oauth2Config: TAuthConfig = {
  clientId: OAUTH_ClIENT_ID,
  authorizationEndpoint: OAUTH_AUTH_API,
  tokenEndpoint: OAUTH_TOKEN_API,
  redirectUri: OAUTH_REDIRECT_URI,
  scope: 'openid profile email password',
  extraTokenParameters: {
    client_secret: OAUTH_CLIENT_SECRET,
  },
}

export const OAuth2Provider: React.FC<OAuth2ProviderProps> = ({ children }) => {
  const [params] = useSearchParams()
  const isSSO = params.get('sso') === 'auto'

  return (
    <AuthProvider
      authConfig={{ ...oauth2Config, autoLogin: isSSO ? true : false }}
    >
      {children}
    </AuthProvider>
  )
}
